import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { AsyncSubject } from 'rxjs';

export interface CacheRequestEntry {
  url: string;
  response: AsyncSubject<HttpResponse<any>>;
  lastUpdated: number;
}

export abstract class CacheRequest {
  abstract get(url: string): AsyncSubject<HttpResponse<any>> | undefined;
  abstract set(url: string, response: AsyncSubject<HttpResponse<any>>): void;
  abstract delete(url: string): void;
}

const maxAge = 1800000; // maximum cache age (ms) 1800000 => 30 mins

@Injectable({
  providedIn: 'root'
})
export class CacheRequestService implements CacheRequest {

  cachedData = new Map<string, CacheRequestEntry>();
  //cache: { [name: string]: AsyncSubject<HttpEvent<any>> } = {};

  constructor(
  ) {
    //this.loadCacheData();
  }

  get(url: string): AsyncSubject<HttpResponse<any>> | undefined {
    const cached = this.cachedData.get(url);

    if (!cached || cached.lastUpdated < (Date.now() - maxAge)) {
      console.log('cache:get', url, 'not');
      return undefined;
    }
    console.log('cache:get', url, this.cachedData);
    return cached.response;
  }

  set(url: string, response: AsyncSubject<HttpResponse<any>>): void {
    console.log('cache:set', url, this.cachedData);
    const entry: CacheRequestEntry = { url, response, lastUpdated: Date.now() };

    this.cachedData.set(url, entry);

    this.removeExpired();
  }

  delete(url: string, useLikePattern: boolean = false): void {
    if (useLikePattern) {
      const urlBase = url.split("?")[0];
      this.cachedData.forEach(entry => {
        const urlBaseCached = entry.url.split("?")[0];
        if (urlBaseCached == urlBase) {
          this.cachedData.delete(entry.url);

          console.log('cache:del', url, useLikePattern, urlBaseCached);
        }
      });
    } else {
      const cached = this.cachedData.get(url);
      if (cached) {
        console.log('cache:del', url, useLikePattern);
      }

      this.cachedData.delete(url);//ToDo V improve if pending
    }
  }

  private removeExpired(): void {
    const expirationDate = Date.now() - maxAge;
    this.cachedData.forEach(entry => {
      if (entry.lastUpdated <= expirationDate) {
        this.cachedData.delete(entry.url);
      }
    });
  }
}
